import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface Toast {
  id: number;
  message: string;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly toasts$ = new BehaviorSubject<Toast[]>([]);
  private nextId = 1;

  readonly toasts: Observable<Toast[]> = this.toasts$.asObservable();

  show(message: string, durationMs: number = 5000): void {
    const toast: Toast = { id: this.nextId++, message };

    this.toasts$.next([...this.toasts$.value, toast]);

    setTimeout(() => this.dismiss(toast.id), durationMs);
  }

  dismiss(id: number): void {
    this.toasts$.next(this.toasts$.value.filter(t => t.id !== id));
  }
}
